<template>
  <span class="ingredient-count">
    <span class="ingredient__qty" v-html="quantityDisplay()"></span>
    <span class="ingredient__unit" v-if="unit" v-html="unit" />
  </span>
</template>
<script>
export default {
  name: "IngredientCount",
  props: {
    unit: {},
    counter: {},
    quantity: {},
    nbPerson: {},
    prefix: { default: "" },
    context: {}
  },
  created() {},
  methods: {
    debugme() {
      return {
        unit: this.unit,
        counter: this.counter,
        quantity: this.quantity,
        nbPerson: this.nbPerson,
        prefix: this.prefix,
        context: this.context
      };
    },
    calcQuantity() {
      return (this.counter / this.nbPerson) * this.quantity;
    },
    quantityRound() {
      return Math.round(this.calcQuantity() * 10) / 10;
    },
    quantityDisplay() {
      let withFraction = [false, "cup", "cs", "cc"];
      if (withFraction.includes(this.unit)) {
        return this.numberToFraction();
      } else {
        return this.quantityRound();
      }
    },
    numberToFraction() {
      // ⅓, ⅔, ¼, ¾, ⅕, ⅖, ⅗, ⅘, ⅙, ⅚, ⅐, ⅛, ⅜, ⅝, ⅞, ⅑, ⅒, ⅟
      const amount = Math.round(this.calcQuantity() * 100) / 100;
      const integerValue = Math.floor(amount);
      let decimalValue = amount - integerValue;
      // Fix javascript substraction bug (avoid number like 5.0000000001)
      decimalValue = parseFloat(decimalValue.toFixed(2));
      let fraction = false;
      switch (decimalValue) {
        case 0.13:
          fraction = "⅛";
          break;
        case 0.25:
          fraction = "¼";
          break;
        case 0.33:
          fraction = "⅓";
          break;
        case 0.5:
          fraction = "½";
          break;
        case 0.66:
          fraction = "⅔";
          break;
        case 0.75:
          fraction = "¾";
          break;
        default:
          return this.quantityRound();
      }
      const formatedFraction = "<sup>" + fraction + "</sup>";
      return integerValue ? integerValue + formatedFraction : formatedFraction;
    }
  }
};
</script>
